var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row nav-top",attrs:{"id":"header"}},[_c('div',{staticClass:"col-lg-3 nav-link nav-string"},[_vm._v("Welcome!")]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 nav-link nav-time"},[_vm._v("\r\n        "+_vm._s(_vm.currentTime)+"\r\n        "),_c('div',{staticClass:"nav-date"},[_vm._v(_vm._s(_vm.currentDate))])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 nav-link nav-user"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1f3d918","hasScoped":false,"buble":{"transforms":{}}}!./src/components/external/header/header.html
// module id = 603
// module chunks = 15